import { render, staticRenderFns } from "./CaseResults.vue?vue&type=template&id=4310004f&scoped=true&"
import script from "./CaseResults.vue?vue&type=script&lang=js&"
export * from "./CaseResults.vue?vue&type=script&lang=js&"
import style0 from "./CaseResults.vue?vue&type=style&index=0&id=4310004f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310004f",
  null
  
)

export default component.exports